import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { InterfaceService } from "@app/interfaces";
import { SharedModalService } from "@app/shared-modal/service/shared-modal.service";
var ActivityAddTagComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ActivityAddTagComponent, _super);
    function ActivityAddTagComponent(sharedModalService) {
        var _this = _super.call(this) || this;
        _this.sharedModalService = sharedModalService;
        _this.selectedTagsList = [];
        _this.isDropdownOnTop = false;
        _this.tagSelected = new EventEmitter();
        _this.tagRemoved = new EventEmitter();
        _this.searchText = '';
        _this.filteredTags = [];
        _this.isKeyboardMode = true;
        _this.activeIndex = -1;
        _this.hoveredIndex = -1;
        _this.pointerInside = false;
        _this.hashtags = [];
        _this.activities = [];
        _this.isDropdownOpen = false;
        _this.loadingHashtags = true;
        _this.documentClickListener = _this.onDocumentClick.bind(_this);
        return _this;
    }
    ActivityAddTagComponent.prototype.ngOnInit = function () {
        // if (this.hashtags.length === 0) {
        //     this.sharedModalService.getHashTagsList().subscribe((response: any) => {
        //         this.hashtags = response.hashtags;
        //         this.filteredTags = [...this.hashtags];
        //         this.resetDropdownState();
        //     });
        // } else {
        //     this.filteredTags = [...this.hashtags];
        //     this.resetDropdownState();
        // }
    };
    ActivityAddTagComponent.prototype.toggleDropdown = function () {
        var _this = this;
        // this.filteredTags = [...this.hashtags];
        if (this.hashtags.length === 0) {
            this.sharedModalService.getHashTagsList().subscribe(function (response) {
                _this.hashtags = response.hashtags;
                _this.filteredTags = _this.hashtags.slice();
                _this.loadingHashtags = false;
                _this.resetDropdownState();
            });
        }
        else {
            this.filteredTags = this.hashtags.slice();
            this.loadingHashtags = false;
            this.resetDropdownState();
        }
        this.isDropdownOpen = true;
        document.addEventListener('click', this.documentClickListener, true);
        setTimeout(function () {
            if (_this.dropdownInputs) {
                var inputElement = _this.dropdownInputs.nativeElement;
                inputElement.focus();
            }
        }, 10);
    };
    ActivityAddTagComponent.prototype.onDocumentClick = function (event) {
        if (!this.isDropdownOpen)
            return;
        var target = event.target;
        if (this.dropdownWrapper && !this.dropdownWrapper.nativeElement.contains(target)) {
            this.resetDropdown();
        }
    };
    ActivityAddTagComponent.prototype.filterTags = function () {
        var term = this.searchText.trim().toLowerCase();
        this.filteredTags = this.hashtags.filter(function (tag) {
            return tag.description.toLowerCase().includes(term);
        });
        // reset to top when filtering
        this.activeIndex = this.filteredTags.length > 0 ? 0 : -1;
        this.hoveredIndex = -1;
        this.isKeyboardMode = true;
    };
    ActivityAddTagComponent.prototype.onKeyDown = function (event) {
        var _this = this;
        var term = this.searchText.trim();
        if (!this.filteredTags.length && term === '')
            return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            // switch to keyboard mode; start from hovered item if mouse is inside
            this.isKeyboardMode = true;
            if (this.pointerInside && this.hoveredIndex >= 0) {
                this.activeIndex = this.hoveredIndex;
                this.hoveredIndex = -1; // handover to keyboard
            }
            if (event.key === 'ArrowDown') {
                if (this.activeIndex < this.filteredTags.length - 1)
                    this.activeIndex++;
            }
            else {
                if (this.activeIndex > 0)
                    this.activeIndex--;
            }
            // keep active item visible INSIDE the dropdown
            setTimeout(function () {
                var dropdownMenu = event.target
                    .closest('.dropdown').querySelector('.dropdown-menu');
                var el = dropdownMenu.querySelector("li[data-index=\"" + _this.activeIndex + "\"]");
                if (el) {
                    el.scrollIntoView({ block: 'nearest' });
                }
            }, 0);
        }
        else if (event.key === 'Enter') {
            event.preventDefault();
            var indexToUse = this.isKeyboardMode ? this.activeIndex : this.hoveredIndex;
            if (indexToUse >= 0) {
                this.selectTag(this.filteredTags[indexToUse]);
            }
            else {
                this.onEnter();
            }
        }
        else if (event.key === 'Escape') {
            event.preventDefault();
            this.resetDropdown();
        }
    };
    ActivityAddTagComponent.prototype.onDropdownMouseEnter = function () {
        this.pointerInside = true;
    };
    ActivityAddTagComponent.prototype.onDropdownMouseLeave = function () {
        this.pointerInside = false;
        this.hoveredIndex = -1;
    };
    ActivityAddTagComponent.prototype.onDropdownScroll = function () {
        if (this.pointerInside)
            this.isKeyboardMode = true;
    };
    ActivityAddTagComponent.prototype.selectTag = function (tag) {
        if (!this.selectedTagsList.find(function (t) { return t.id == tag.id; })) {
            this.selectedTagsList.push(tag);
            this.tagSelected.emit(tag);
        }
        this.resetDropdown();
    };
    ActivityAddTagComponent.prototype.removeTag = function (tag) {
        this.selectedTagsList = this.selectedTagsList.filter(function (t) { return t.id != tag.id; });
        this.tagRemoved.emit(tag);
    };
    ActivityAddTagComponent.prototype.resetDropdownState = function () {
        this.activeIndex = this.filteredTags.length > 0 ? 0 : -1;
        this.hoveredIndex = -1;
        this.isKeyboardMode = true;
        this.pointerInside = false;
    };
    ActivityAddTagComponent.prototype.onEnter = function () {
        var _this = this;
        var term = this.searchText.trim();
        if (!term)
            return;
        var existing = this.hashtags.find(function (tag) { return tag.description.toLowerCase() === term.toLowerCase(); });
        if (existing) {
            this.selectTag(existing);
        }
        else {
            var tagValue = [];
            tagValue.push(term);
            var data = { activityId: this.activity ? this.activity.activityId : null, tags: tagValue };
            this.sharedModalService.saveActivityTag(data).subscribe(function (data) {
                var tagObj = { id: data, description: term };
                _this.hashtags.push(tagObj);
                if (!_this.selectedTagsList.find(function (t) { return t.id == tagObj.id; })) {
                    _this.selectedTagsList.push(tagObj);
                }
                if (!_this.activity && _this.isDropdownOnTop) {
                    _this.tagSelected.emit(tagObj);
                }
            });
        }
        this.resetDropdown();
    };
    ActivityAddTagComponent.prototype.resetDropdown = function () {
        this.searchText = '';
        this.filteredTags = this.hashtags.slice();
        this.isDropdownOpen = false;
        document.removeEventListener('click', this.documentClickListener, true);
    };
    ActivityAddTagComponent.prototype.ngOnDestroy = function () {
        this.resetDropdownState();
        this.resetDropdown();
        document.removeEventListener('click', this.documentClickListener, true);
        this.selectedTagsList = [];
    };
    return ActivityAddTagComponent;
}(InterfaceService));
export { ActivityAddTagComponent };
